/* global UserProfileURL */

import _ from 'topmeteo/utils/i18n';

import NotAvailable from './NotAvailable';
import TranslatedLink from './TranslatedLink';

const Message = _('You are not connected to WeGlide. Go to your <a>user profile</a> to connect your accounts.');

const WeGlideNotConnectedMessage = props => (
    <NotAvailable {...props}>
        <TranslatedLink message={Message} href={UserProfileURL} />
    </NotAvailable>
);

export default WeGlideNotConnectedMessage;
